import { daysUntilExpiry, RENEWAL_WARN_DAYS } from '@iws/backoffice-api'
import { Link } from 'react-router-dom'
import { useEffect, useState } from 'react'

import { useAuth } from '@/contexts/AuthContext'
import { RenewalModel } from '@/http/models/Renewal'

/**
 * Warns from `RENEWAL_WARN_DAYS` before the subscription ends, and after (POS.md §13.3). Staff who can see renewals
 * get a link to Settings → Subscription; a request waiting for review is said so instead.
 */
export const RenewalAlertBar = () => {
  const { can } = useAuth()
  const allowed = can('renewals:list')
  const [state, setState] = useState<{ days: number | null; pending: boolean } | null>(null)

  useEffect(() => {
    if (!allowed) return
    RenewalModel.getList().then((res) => {
      if (res.success && res.data) {
        setState({ days: daysUntilExpiry(res.data.expiration_date), pending: res.data.result.some((r) => r.status === 'pending') })
      }
    })
  }, [allowed])

  if (!allowed || !state || state.days === null || state.days > RENEWAL_WARN_DAYS) return null
  const { days, pending } = state
  const expired = days < 0
  const text = expired
    ? `Your subscription expired ${Math.abs(days)} day${Math.abs(days) === 1 ? '' : 's'} ago.`
    : days === 0
      ? 'Your subscription expires today.'
      : `Your subscription expires in ${days} day${days === 1 ? '' : 's'}.`

  return (
    <div role="status" className={expired ? 'bg-error-lighter px-4 py-2 text-sm text-error-dark' : 'bg-warning-lighter px-4 py-2 text-sm text-warning-dark'}>
      {text}{' '}
      {pending ? (
        'Your renewal is waiting for review.'
      ) : (
        <Link to="/settings/subscription" className="font-medium underline">
          Renew now
        </Link>
      )}
    </div>
  )
}
